export const VENUE_ACTION_PREFIX = "data";

export const VENUE_ACTIONS = {
  getSearchVenues: `${VENUE_ACTION_PREFIX}/venues?search`,
  getUserVenues: `${VENUE_ACTION_PREFIX}/venues?user`,
  getVenue: `${VENUE_ACTION_PREFIX}/venue/get`,
  editVenue: `${VENUE_ACTION_PREFIX}/venue/edit`,
  deleteVenue: `${VENUE_ACTION_PREFIX}/venue/delete`,
  createVenue: `${VENUE_ACTION_PREFIX}/venues/create`,
  createStage: `${VENUE_ACTION_PREFIX}/stage/create`,
  getStage: `${VENUE_ACTION_PREFIX}/stage/get`,
  deleteStage: `${VENUE_ACTION_PREFIX}/stage/delete`,
  editStage: `${VENUE_ACTION_PREFIX}/stage/edit`,
  createStageCapacity: `${VENUE_ACTION_PREFIX}/stage/capacity/create`,
  deleteStageCapacity: `${VENUE_ACTION_PREFIX}/stage/capacity/delete`,
  editStageCapacity: `${VENUE_ACTION_PREFIX}/stage/capacity/edit`,
  editStageEquipmentCategories: `${VENUE_ACTION_PREFIX}/stage/equipmentCategories/edit`,
  createEquipment: `${VENUE_ACTION_PREFIX}/equipment/create`,
  getEquipment: `${VENUE_ACTION_PREFIX}/equipment/get`,
  editEquipment: `${VENUE_ACTION_PREFIX}/equipment/edit`,
  deleteEquipment: `${VENUE_ACTION_PREFIX}/equipment/delete`,
  getStageEquipment: `${VENUE_ACTION_PREFIX}/stage/equipment/get`,
  getInfoBlock: `${VENUE_ACTION_PREFIX}/infoBlock/get`,
  editInfoBlock: `${VENUE_ACTION_PREFIX}/infoBlock/edit`,
  createInfoBlock: `${VENUE_ACTION_PREFIX}/infoBlock/create`,
  deleteInfoBlock: `${VENUE_ACTION_PREFIX}/infoBlock/delete`,
  getVenueInfoBlockItems: `${VENUE_ACTION_PREFIX}/venue/infoBlockItems`,
  getInfoBlockItem: `${VENUE_ACTION_PREFIX}/infoBlockItem/get`,
  getInfoBlocks: `${VENUE_ACTION_PREFIX}/infoBlocks/get`,
  getStageInfoBlocks: `${VENUE_ACTION_PREFIX}/infoBlocks/get?stage`,
  getVenueInfoBlocks: `${VENUE_ACTION_PREFIX}/infoBlocks/get?venue`,
  createInfoBlockItem: `${VENUE_ACTION_PREFIX}/infoBlockItem/create`,
  editInfoBlockItem: `${VENUE_ACTION_PREFIX}/infoBlockItem/edit`,
  deleteInfoBlockItem: `${VENUE_ACTION_PREFIX}/infoBlockItem/delete`,
  editVenueStageOrder: `${VENUE_ACTION_PREFIX}/venue/edit/stageOrder`,
  publishVenue: `${VENUE_ACTION_PREFIX}/publishVenue`,
  unpublishVenue: `${VENUE_ACTION_PREFIX}/unpublishVenue`,
  requestPublishVenue: `${VENUE_ACTION_PREFIX}/requestPublishVenue`,
  inviteEditor: `${VENUE_ACTION_PREFIX}/venueEditor/create`,
  inviteEditors: `${VENUE_ACTION_PREFIX}/venueEditors/create`,
  getEditorInvite: `${VENUE_ACTION_PREFIX}/venueEditor/get`,
  unlinkEditor: `${VENUE_ACTION_PREFIX}/venueEditor/unlink`,
  revokeEditorInvite: `${VENUE_ACTION_PREFIX}/venueEditor/revoke`,
  isOnlyVenueUser: `${VENUE_ACTION_PREFIX}/isOnlyVenueUser`,
  suggestEdit: `${VENUE_ACTION_PREFIX}/suggestEdit`,
  editVenueBands: `${VENUE_ACTION_PREFIX}/venue/edit/bands`,
};

export type IVenueActions = typeof VENUE_ACTIONS[keyof typeof VENUE_ACTIONS];
